// extracted by mini-css-extract-plugin
module.exports = {"inner-wrapper":"_2QRb9","flex-grid":"_3QWcS","now-playing":"_1noS_","iframeYT":"sUvLg","video-list":"_1hGZ9","video-item":"Kspn6","thumb":"_2egrr","video-title":"_1uZDY"};